import React, { useState } from 'react';
import { Box, Button, Grid, Modal, Typography } from '@mui/material';
import { FILTER_FLOAT_BUTTON_Z_INDEX } from 'src/const';
import TabBar from 'src/App/Components/Tabs/TabBar';
import { COLOR_PRIMARY_2 } from 'src/colors';

const BottomDrawer = ({
  topComponents,
  components,
  isOverLayVisible,
  overlayButton,
  modalComponents,
}: {
  topComponents: JSX.Element[];
  components: JSX.Element[];
  isOverLayVisible: boolean;
  overlayButton: JSX.Element;
  modalComponents: JSX.Element[];
}) => {
  const mobileDrawerTabs = [
    {
      label: 'Overview',
      value: 'overview',
      icon: null,
      onclick: () => {},
    },
    {
      label: 'Listings',
      value: 'listings',
      icon: null,
      onclick: () => {
        handleListingsModalOpen();
      },
    },
  ];

  const [listingsModalOpen, setListingsModalOpen] = useState(false);
  const handleListingsModalOpen = () => setListingsModalOpen(true);
  const handleListingsModalClose = () => setListingsModalOpen(false);

  return (
    <>
      <Box
        sx={{
          position: 'absolute',
          left: 0,
          bottom: 0,
          width: '100%',
          height: '40vh',
          maxHeight: '80vh',
          display: 'flex',
          flexDirection: 'column',
        }}
      >
        <Box
          sx={{
            height: '30px',
            display: 'flex',
            justifyContent: 'space-between',
            padding: 'auto 5px',
            paddingLeft: '10px',
            marginRight: '10px',
            paddingBottom: '5px',
          }}
        >
          {topComponents.map(component => component)}
        </Box>

        <Box
          sx={{
            backgroundColor: '#fff',
            borderTopLeftRadius: '24px',
            borderTopRightRadius: '24px',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
          }}
        >
          <TabBar
            tabList={mobileDrawerTabs}
            currentTab={'overview'}
            color={COLOR_PRIMARY_2}
            renderLabelCondition={() => true}
            actionButton={[]}
            showActionButton={false}
            transparentBackground={true}
          />
        </Box>

        <Box
          sx={{
            flex: 1,
            overflowY: 'auto',
            background: '#fff',
            width: '100%',
            pl: 2,
            pr: 2,
            position: 'relative',
          }}
        >
          {isOverLayVisible && (
            <Box
              sx={{
                position: 'absolute',
                top: 0,
                left: 0,
                width: '100%',
                height: '3400px',
                backgroundColor: 'rgba(255, 255, 255, 0.8)',
                zIndex: FILTER_FLOAT_BUTTON_Z_INDEX - 1,
              }}
            >
              <div
                style={{
                  position: 'sticky',
                  top: '25%',
                  display: 'flex',
                  justifyContent: 'center',
                }}
              >
                {overlayButton}
              </div>
            </Box>
          )}

          <Grid
            container
            direction="column"
            xs={12}
            spacing={2}
            justifyContent="flex-start"
            alignItems="center"
          >
            <Grid item xs={12} sx={{ width: '100%' }}></Grid>
            {components.map((component, index) => (
              <Grid item xs={12} key={index} sx={{ width: '100%' }}>
                {component}
              </Grid>
            ))}
          </Grid>
        </Box>
      </Box>

      <Modal
        open={listingsModalOpen}
        onClose={handleListingsModalClose}
        aria-labelledby="modal-title"
        aria-describedby="modal-description"
        sx={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
        }}
      >
        <Box
          sx={{
            width: '90vw',
            height: '80vh',
            backgroundColor: 'white',
            borderRadius: '16px',
            boxShadow: 24,
            padding: '16px',
            overflowY: 'auto',
            outline: 'none',
          }}
        >
          <Grid item xs={12} sx={{ width: '100%' }}>
            {modalComponents[0]}
          </Grid>

          <Box
            sx={{
              height: '65vh',
              backgroundColor: 'white',
              overflowY: 'auto',
            }}
          >
            <Grid
              container
              direction="column"
              xs={12}
              spacing={2}
              justifyContent="flex-start"
              alignItems="center"
            >
              {modalComponents.slice(1).map((component, index) => (
                <Grid item xs={12} key={index} sx={{ width: '100%' }}>
                  {component}
                </Grid>
              ))}
            </Grid>
          </Box>
        </Box>
      </Modal>
    </>
  );
};

export default BottomDrawer;
